import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { logger } from '../../../../utils/logger';
import { orderRedirectPaymentCreateValidator } from '../../../../utils/validators/order-redirect-payment-create';
import { getOrder } from '../../selectors/order/get-order';
import { assertIsOrderCreated } from '../../utils/order-type-utils';
import { registerOrderAction } from '../utils/register-order-action';
export const createOrderRedirectPayment = async (request) => {
    const order = getOrder();
    assertIsOrderCreated(order, 'Cannot create redirect payment');
    if (!orderRedirectPaymentCreateValidator(request, logger.info, 'OrderRedirectPaymentCreate')) {
        throw new Error('Cannot create redirect payment. Details provided are invalid.');
    }
    let response;
    const deregisterAction = registerOrderAction('create-order-redirect-payment');
    try {
        response = await ocapiClient.instance.v1.orders.payments.redirect.create(order.id, request);
    }
    finally {
        deregisterAction();
    }
    return response;
};
